
import { defineComponent } from 'vue'
import { BIconCloudDownload } from 'bootstrap-icons-vue'

export default defineComponent({
  name: 'DownloadView',
  components: {
    BIconCloudDownload,
  },
  props: {
    loading: Boolean,
  },
  methods: {
    download() {
      this.$emit('download')
    },
  },
})
